import {
  GET_EDUCATIONLEVEL,
  GET_EDUCATIONLEVEL_SUCCESS,
  GET_EDUCATIONLEVEL_FAIL,
  DELETE_EDUCATIONLEVEL,
  DELETE_EDUCATIONLEVEL_SUCCESS,
  DELETE_EDUCATIONLEVEL_FAIL,
  UPDATE_EDUCATIONLEVEL,
  UPDATE_EDUCATIONLEVEL_SUCCESS,
  UPDATE_EDUCATIONLEVEL_FAIL,
  ADD_NEW_EDUCATIONLEVEL,
  ADD_EDUCATIONLEVEL_SUCCESS,
  ADD_EDUCATIONLEVEL_FAIL,
  EDUCATIONLEVEL_LOADING,
  EDUCATIONLEVEL_RESET,
} from "./actionType";

export const resetEducationLevelState = (actionType) => ({
  type: EDUCATIONLEVEL_RESET,
  payload: { actionType },
});

export const getEducationLevelSuccess = (actionType, data) => ({
  type: GET_EDUCATIONLEVEL_SUCCESS,
  payload: { actionType, data },
});

export const getEducationLevelFail = (actionType, error) => ({
  type: GET_EDUCATIONLEVEL_FAIL,
  payload: { actionType, error },
});

export const getEducationLevel = data => ({
  type: GET_EDUCATIONLEVEL,
  payload: data,
});

export const getEducationLevelLoading = () => ({
  type: EDUCATIONLEVEL_LOADING
});

export const deleteEducationLevel = data => ({
  type: DELETE_EDUCATIONLEVEL,
  payload: data,
});

export const deleteEducationLevelSuccess = data => ({
  type: DELETE_EDUCATIONLEVEL_SUCCESS,
  payload: data,
});

export const deleteEducationLevelFail = error => ({
  type: DELETE_EDUCATIONLEVEL_FAIL,
  payload: error,
});

export const updateEducationLevel = data => ({
  type: UPDATE_EDUCATIONLEVEL,
  payload: data,
});

export const updateEducationLevelFail = error => ({
  type: UPDATE_EDUCATIONLEVEL_FAIL,
  payload: error,
});

export const updateEducationLevelSuccess = data => ({
  type: UPDATE_EDUCATIONLEVEL_SUCCESS,
  payload: data,
});

export const addNewEducationLevel = data => ({
  type: ADD_NEW_EDUCATIONLEVEL,
  payload: data,
});

export const addEducationLevelSuccess = data => ({
  type: ADD_EDUCATIONLEVEL_SUCCESS,
  payload: data,
});

export const addEducationLevelFail = error => ({
  type: ADD_EDUCATIONLEVEL_FAIL,
  payload: error,
});